<template>


<div>
  <FieldLabel v-if="showFieldHelp" :label="item.name" :help="fieldHelp" :input-id="fieldInputId" :field-id="item.id" :modal-key="modalKey" />
  <div class="field-textarea">

  <v-tooltip v-if="showTranslationAction" top>
    <template v-slot:activator="{ on, attrs }">
      <span v-bind="attrs" v-on="on">
        <v-btn class="field-textarea__translation-button" icon small color="indigo" :disabled="!canTranslate" @click="translationDialog = true"><v-icon>mdi-earth</v-icon></v-btn>
      </span>
    </template>
    <span>{{ canTranslate ? 'Gérer les traductions' : "Enregistrez d'abord la fiche pour ajouter des traductions" }}</span>
  </v-tooltip>


  <v-menu  v-model="menu" top nudge-bottom="23" nudge-left="0" :close-on-content-click="false" v-if="items && items.length">
            <template v-slot:activator="{ on }">
              <v-btn class="secondary float-left ma-2" v-on="on" small dark icon><v-icon>mdi mdi-list-box-outline</v-icon></v-btn>
            </template>
            <v-card>
              <v-card-text class="pa-0">

                      <Table
                      :Headers="[{text:'selectionnez votre choix',value:'text'}]"
                      :datas="items"
                      :isDraggable="false"
                      :editTable="selRow"
                      :del="false"
                      :hidesearch="false"
                      :hidefooter="false"
                      />

              </v-card-text>
            </v-card>
          </v-menu> 


          <v-textarea
            :id="fieldInputId"
            :label="showFieldHelp ? undefined : item.name"
            :aria-label="item.name"
            v-model="model"
            :auto-grow="prop.autogrow"
            :rows="prop.row"
            @keyup="keyup(item,model,false)" 
            @keyup.enter="keyup(item,model,true)"
            :type="item.format"

            :rules="prop.modelRules"
            v-if="prop.show"
            :outlined="prop.outlined"
            :filled="prop.filled"
            :solo="prop.solo"
            :hint="prop.description"
            :persistent-hint="prop.persistenthint"
            :disabled="prop.disabled"
            :class="prop.class"
            :clearable="prop.clearable"
            :color="prop.coloronselect"
            @click:clear="keyup(item,'')"
            :prepend-icon="(prop.iconlr=='prepend' && prop.iconinout=='out') ? prop.iconmdi : ''"
            :prepend-inner-icon="(prop.iconlr=='prepend' && prop.iconinout!='out') ? prop.iconmdi : ''"
            :append-icon="(prop.iconlr=='append' && prop.iconinout!='out') ? prop.iconmdi : ''"
            :append-outer-icon="(prop.iconlr=='append' && prop.iconinout=='out') ? prop.iconmdi : ''" 
            
          ></v-textarea>    

          <FieldTranslationsDialog
            v-if="showTranslationAction && canTranslate"
            v-model="translationDialog"
           :field-id="item.id"
            :line-id="translationLineId"
            :field-name="item.name"
            :source-value="model"
          />
</div>
</div>

</template>



<script>
import mixinFields from '../../mixins/Fields'
import mixinConditionsFields from '../../mixins/conditionsFields'
import Table from '../engine/outils/simpleTable' 
import FieldTranslationsDialog from './FieldTranslationsDialog'

    export default {
        name : 'TextArea',

        mixins : [mixinFields,mixinConditionsFields],

        components : {
                Table,
                FieldTranslationsDialog,
            },  

        data: function() {
            return { 
                changeStore : false,
                menu : false,
                translationDialog: false,
                selRow : [{icon:'mdi-import',action:(item)=>{this.selectItem(item)}}],
            }
        },

        computed: {
          showTranslationAction() { return this.type === 'form' && this.item.isTranslatable === true },
          translationLineId() { return this.params && this.params.id },
          canTranslate() {
            return this.translationLineId !== undefined && this.translationLineId !== null && this.translationLineId !== '' && this.translationLineId !== 'new'
          }
        },

        methods : {

            selectItem(item) {
              //ds conditionsFields.js, permet de vérifier le changement soit par la liste, soit à l'écrit
                this.onSelect  = true
                let defaultKey = item.default;
                this.keyup(this.item,item[defaultKey],false);
                this.model = item[defaultKey]
                this.menu = false;
            }



        },


    }

</script>

<style scoped>
.field-textarea {
  display: flex;
  align-items: flex-start;
  width: 100%;
  min-width: 0;
}

.field-textarea__translation-button {
  flex: 0 0 auto;
  margin: 4px 8px 0 0;
}

.field-textarea ::v-deep .v-input {
  flex: 1 1 auto;
  min-width: 0;
}
</style>
